import React from 'react'
import { storiesOf } from '@storybook/react'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import Shrink from 'components/Shrink'

const styles = createStyles({
  shrink: {
    margin: 32,
    display: 'inline-block',
  },
  circle: {
    width: 64,
    height: 64,
    borderRadius: 32,
    backgroundColor: '#f3f',
  }
})

const ToggleContext = React.createContext({
  animateIn: false,
})

class Container extends React.Component<{}, { animateIn: boolean }> {
  constructor(props: {}) {
    super(props)
    this.state = { animateIn: false }
  }

  render() {
    return (
      <ToggleContext.Provider value={{ animateIn: this.state.animateIn }}>
        {this.props.children}
        <br/>
        <button onClick={() => this.setState({ animateIn: !this.state.animateIn })}>Toggle Animation</button>
      </ToggleContext.Provider>
    )
  }
}

const Default: React.SFC<{animateIn: boolean} & WithStyles<typeof styles>> = ({classes, animateIn}) => (
  <Shrink className={classes.shrink} in={animateIn} timeout={0}>
    <div className={classes.circle} />
  </Shrink>
)

const DecoratedDefault = withStyles(styles)(Default)

const Group: React.SFC<{animateIn: boolean} & WithStyles<typeof styles>> = ({classes, animateIn}) => (
  <>
    {Array(4).fill(null).map((_, i) => (
      <Shrink key={`shrink-${i}`} className={classes.shrink} in={animateIn} timeout={i * 200}>
        <div className={classes.circle} />
      </Shrink>
    ))}
  </>
)

const DecoratedGroup = withStyles(styles)(Group)

storiesOf('Shrink', module)
  .addDecorator((story) => (
    <Container>{story()}</Container>
  ))
  .add('default', () => (
    <ToggleContext.Consumer>
      {({ animateIn }) => (
        <DecoratedDefault animateIn={animateIn} />
      )}
    </ToggleContext.Consumer>
  ))
  .add('group', () => (
    <ToggleContext.Consumer>
      {({ animateIn }) => (
        <DecoratedGroup animateIn={animateIn} />
      )}
    </ToggleContext.Consumer>
  ))
